import React from "react"
import store from "store"
import { blockingFetchService } from "../../lib/blockingFetch"
import authServerApi from "../../redux/sagas/authServerApi"
import AlertModal from "../fragments/AlertModal"
import ProcessesStatus from "../fragments/ProcessesStatus"

class StopImpersonationModal extends React.Component {

  state = {
    running: false,
    error: null,
  }

  proceedClicked = () => {

    this.setState({
      running: true,
      error: null,
    })

    blockingFetchService(
      accessToken => authServerApi.impersonation(accessToken, ''),
      user => {
        store.set('userInfo', user)
        store.remove('organization')
        window.location.href = '/organizations'
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  close = () => {

    this.setState({
      running: false,
      error: null,
    })
    this.props.close()
  }

  stopContent = () => {
    const { running, success, error } = this.state,
    { organization } = this.props
    return (
      <div>
        <h3 className="red">Stop impersonating &#171; { organization.name } &#187;</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  render() {
    const { show } = this.props,
    { running } = this.state

    return (
      <AlertModal
        show={ show }
        title='Stopping'
        body={ this.stopContent() }
        bsStyle="danger"
        close={ this.close }
        confirm={ this.proceedClicked }
        proceedText="Stop"
        disabled={ running }
      />
    )
  }
}

export default StopImpersonationModal



// WEBPACK FOOTER //
// ./src/components/App/StopImpersonationModal.js